/**
 * Where the EXTENDED fx visuals live — the shader-pack visuals that are not bundled in the app (the
 * offline CORE set is, under public/fx). Packages at `<base><pack>/<slug>.<sha12>.json` (content-addressed:
 * a new version is a new object, never an overwrite), previews at
 * `<base>previews/<pack>/<slug>.jpg`, the upload manifest (also the app's reachability probe) at
 * `<base>manifest.json`. Uploaded by scripts/fx/upload-fx-ext.mjs from what scripts/fx/build-fx-packs.mjs
 * writes to dist-fx-ext/.
 *
 * The SYQEL INC R2 bucket `syqel-art-media` under its custom domain, prefix fx-ext/ (owner decision: a
 * dedicated media bucket, never the OTA registry's). Override per build with VITE_FX_EXT_BASE (absolute,
 * ending in '/'). Pure — the build config (catalogue.json `fxBase`) and the app read the same answer.
 * The app trusts the base only as far as fxWorlds.ts verifies it: the probe needs the base's own versioned
 * index.json, and every package must match the sha256 the app bundles (fxIntegrity.json).
 */
export const FX_EXT_BASE_DEFAULT = 'https://media.syqel.art/fx-ext/'

export function fxExtBase(env: { VITE_FX_EXT_BASE?: string } | undefined): string {
  const b = env?.VITE_FX_EXT_BASE?.trim()
  if (!b) return FX_EXT_BASE_DEFAULT
  return b.endsWith('/') ? b : `${b}/`
}
